import { ENTRY_TYPES } from '../../utils/categories';

/**
 * EntryTypeSelector - Allows user to choose between Event, Expense, or Both
 * Only shown when creating new entries (not when editing)
 */
export default function EntryTypeSelector({ value, onChange }) {
  return (
    <div>
      <label className="label">Entry Type</label>
      <div className="grid grid-cols-3 gap-2">
        {ENTRY_TYPES.map(type => {
          const isSelected = value === type.value;
          return (
            <button
              key={type.value}
              type="button"
              onClick={() => onChange(type.value)}
              className="p-3 rounded-sm text-left transition-all"
              style={{
                backgroundColor: isSelected ? 'var(--color-brand-primary-soft)' : 'var(--color-bg-raised)',
                border: `2px solid ${isSelected ? 'var(--color-brand-primary)' : 'var(--color-border-subtle)'}`,
              }}
            >
              <div 
                className="font-medium text-sm" 
                style={{ color: 'var(--color-text-primary)' }}
              >
                {type.label}
              </div>
              <div 
                className="text-xs mt-0.5 hidden sm:block" 
                style={{ color: 'var(--color-text-muted)' }}
              >
                {type.description}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
